import { FANTASY_CONSTANTS } from '@pff-consumer/schema'

export const isOnMatchupsTab = (activeTabIndex: number) =>
  FANTASY_CONSTANTS.IN_SEASON_HEADER_TABS.findIndex((tab) => tab === 'Matchups') === activeTabIndex
